import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Icon from "@visa/vds/icon";
import Radio from "@visa/vds/radio";
import RadioErrorMessage from "@visa/vds/radio-error-message";
import RadioGroup from "@visa/vds/radio-group";
import RadioGroupLegend from "@visa/vds/radio-group-legend";
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import { SUBSCRIPTION_DETAILS_STAGE } from "_constants/GlobalConstants";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import MCSSpace from "components/MCSSpace";
import React, { useEffect, useState } from "react";
import { SubscriptionApi } from "services/subscription.service";
import OtherProductDetails from "./Components/SelectProduct/OtherProductDetails";
import { ProductSelectionConst } from "./Components/SelectProduct/ProductSelectionLogic";
import VSTTSubscriptionExistingWarningDialog from "./Components/SelectProduct/VSTTSubscriptionExistingWarningDialog";
import VSTSProductDetails from "./Components/SelectProduct/VSTSProductDetails";
import VSTTProductDetails from "./Components/SelectProduct/VSTTProductDetails";
import "./Style/Store.css";
import VSTSFutureSubscriptionExistWarningDialog from "./Components/SelectProduct/VSTSFutureSubscriptionExistWarningDialog";

const SelectProduct = (props) => {
  let {
    selectedCategory, setSelectedCategory,

    // VSTS
    selectedVSTSSubscriptionInfoId, setselectedVSTSSubscriptionInfoId,
    setSelectedVSTSStartDate,
    setSelectedVSTSEndDate,
    setVSTSSelectedProductInfoDetails,

    // VSTT
    selectedVSTTProducts, setSelectedVSTTProducts,

    handleStepUpdate,
  } = props;
  //VSTS
  const [showCategorySelectedError, setshowCategorySelectedError] = useState(false);
  const [showVSTSProductInfoErrorMessage, setShowVSTSProductInfoErrorMessage] = useState(false);
  const [requireBaseSubscription, setRequireBaseSubscription] = useState(false);
  const [futureSubscription, setFutureSubscription] = useState(null);
  const [openVSTSSubscriptionWarningDialog, setOpenVSTSSubscriptionWarningDialog] = useState(false);
  const [isPerformingChecks, setIsPerformingChecks] = useState(true);

  //VSTT Specific
  const [isVSTTMerchantSelected, setIsVSTTMerchantSelected] = useState(false);
  const [isVSTTACSSelected, setIsVSTTACSSelected] = useState(false);
  const [showVSTTProductAudienceErrorMessage, setShowVSTTProductAudienceErrorMessage] = useState(false);
  const [showVSTTProductEnvironmentErrorMessage, setShowVSTTProductEnvironmentErrorMessage] = useState(false);
  const [openVSTTSubscriptionWarningDialog, setOpenVSTTSubscriptionWarningDialog] = useState(false);
  const [checkExistingVsttSubscriptions, setCheckExistingVsttSubscriptions] = useState(null);

  const pendingRelease = true;

  const handleVSTSSelected = () => {
    setshowCategorySelectedError(false);
    setSelectedCategory(ProductSelectionConst.VSTS_CATEGORY);
  };

  const handleVSTTSelected = () => {
    setshowCategorySelectedError(false);
    setSelectedCategory(ProductSelectionConst.VSTT_CATEGORY);
  };

  const handleOtherTestingSelected = () => {
    setSelectedCategory(ProductSelectionConst.OTHER_CATEGORY);
  };

  const handleVSTSSubscriptionInfoSelected = (subscriptionInfo) => {
    setShowVSTSProductInfoErrorMessage(false);
    console.log('subscriptionInfo: ', subscriptionInfo, ', selectedVSTSSubscriptionInfoId:', selectedVSTSSubscriptionInfoId);
    if (subscriptionInfo !== selectedVSTSSubscriptionInfoId) {
      setSelectedVSTSStartDate(null);
      setSelectedVSTSEndDate(null);
      setVSTSSelectedProductInfoDetails(null);
      setselectedVSTSSubscriptionInfoId(subscriptionInfo);
    }
  };

  const ValidateAndProceed = async () => {
    setIsPerformingChecks(true);
    if (selectedCategory === 0) {
      setshowCategorySelectedError(true);
      setIsPerformingChecks(false);
      return;
    }

    if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
      if (selectedVSTSSubscriptionInfoId === 0) {
        setShowVSTSProductInfoErrorMessage(true);
        setIsPerformingChecks(false);
        return;
      }

      const checkFutureSubscription = await SubscriptionApi.GetFutureSubscription();
      if (checkFutureSubscription.futureSubscription != null) {
        setFutureSubscription(checkFutureSubscription.futureSubscription);
        setOpenVSTSSubscriptionWarningDialog(true);
        setIsPerformingChecks(false);
        return;
      }
    }


    if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
      if (isVSTTMerchantSelected === false && isVSTTACSSelected === false) {
        setShowVSTTProductAudienceErrorMessage(true);
        setIsPerformingChecks(false);
        return;
      }

      if (selectedVSTTProducts.length == 0) {
        setShowVSTTProductEnvironmentErrorMessage(true);
        setIsPerformingChecks(false);
        return;
      }

      // Check if selected VSTT Subscriptions alr exist, if exist show a warning
      const checkExistingVsttSubscriptions =
        await SubscriptionApi.CheckProductSubscriptionExist(selectedVSTTProducts);
      if (
        checkExistingVsttSubscriptions != null &&
        checkExistingVsttSubscriptions.length > 0
      ) {
        setCheckExistingVsttSubscriptions(checkExistingVsttSubscriptions);
        setOpenVSTTSubscriptionWarningDialog(true);
        setIsPerformingChecks(false);
        return;
      }
    }

    handleStepUpdate(SUBSCRIPTION_DETAILS_STAGE);
  };

  const hasVSTSBaseSubscription = async () => {
    var requireBaseCheck = await SubscriptionApi.RequireBaseSubscription();
    setRequireBaseSubscription(requireBaseCheck.requireBaseSubscription);
    setIsPerformingChecks(false);
  };

  useEffect(() => {
    hasVSTSBaseSubscription();
  }, []);

  return (
    <>
      {isPerformingChecks && <MCSOverlayLoading></MCSOverlayLoading>}
      <VSTTSubscriptionExistingWarningDialog
        openSubscriptionWarningDialog={openVSTTSubscriptionWarningDialog}
        setOpenSubscriptionWarningDialog={setOpenVSTTSubscriptionWarningDialog}
        checkExistingVsttSubscriptions={checkExistingVsttSubscriptions}
      />
      <VSTSFutureSubscriptionExistWarningDialog
        openSubscriptionWarningDialog={openVSTSSubscriptionWarningDialog}
        setOpenSubscriptionWarningDialog={setOpenVSTSSubscriptionWarningDialog}
        futureSubscription={futureSubscription}
      />
      <MCSSpace height="30px" />
      <Grid>
        <Row>
          <Col>
            <RadioGroup
              className="select-product-radio"
              invalid={showCategorySelectedError}
            >
              <RadioGroupLegend>Choose a product</RadioGroupLegend>
              <Radio
                id="VSTSSubscriptionRadioBtn"
                checked={
                  selectedCategory === ProductSelectionConst.VSTS_CATEGORY
                }
                label={"Visa Secure Test Suite (VSTS) subscription"}
                name="radio-group-product-select"
                onChange={handleVSTSSelected}
                value={ProductSelectionConst.VSTS_CATEGORY}
              />

              <Typography className="select-product-caption" variant="body">
                VSTS is a certification platform that ensures solution
                providers’ 3DS Server (3DSS) and Access Control Server (ACS)
                software support Visa-specific EMV 3DS requirements and
                specification extensions before connecting to Visa’s EMV 3DS
                Directory Server.
              </Typography>

              {selectedCategory ===
                ProductSelectionConst.VSTS_CATEGORY && (
                  <VSTSProductDetails
                    selectedProductInfo={selectedVSTSSubscriptionInfoId}
                    handleProductInfoSelected={handleVSTSSubscriptionInfoSelected}
                    BASE_SUBSCRIPTION={ProductSelectionConst.BASE_SUBSCRIPTION}
                    EXTENSION_SUBSCRIPTION={
                      ProductSelectionConst.EXTENSION_SUBSCRIPTION
                    }
                    showVSTSProductInfoErrorMessage={
                      showVSTSProductInfoErrorMessage
                    }
                    requireBaseSubscription={requireBaseSubscription}
                  />
                )}

              <Radio
                id="VSTTSubscriptionRadioBtn"
                checked={
                  selectedCategory === ProductSelectionConst.VSTT_CATEGORY
                }
                label="Visa Secure Test Tool (VSTT) subscription"
                name="radio-group-product-select"
                onChange={handleVSTTSelected}
                value={ProductSelectionConst.VSTT_CATEGORY}
                disabled={true}
              />

              <Typography className="select-product-caption" variant="body">
                VSTT are value-add, simulator tools working with a Visa
                Directory Server that provide issuer ACS and 3DS Server entities
                the ability to run extended tests or validation of their EMV 3DS
                implementation.
              </Typography>

              {selectedCategory ===
                ProductSelectionConst.VSTT_CATEGORY && (
                  <VSTTProductDetails
                    isVSTTMerchantSelected={isVSTTMerchantSelected}
                    setIsVSTTMerchantSelected={setIsVSTTMerchantSelected}
                    isVSTTACSSelected={isVSTTACSSelected}
                    setIsVSTTACSSelected={setIsVSTTACSSelected}
                    setSelectedVSTTProducts={setSelectedVSTTProducts}
                    selectedVSTTProducts={selectedVSTTProducts}
                    showVSTTProductAudienceErrorMessage={
                      showVSTTProductAudienceErrorMessage
                    }
                    showVSTTProductEnvironmentErrorMessage={
                      showVSTTProductEnvironmentErrorMessage
                    }
                  />
                )}
              {!pendingRelease && (
                <Radio
                  label="Other"
                  checked={
                    selectedCategory ===
                    ProductSelectionConst.OTHER_CATEGORY
                  }
                  name="radio-group-product-select"
                  onChange={handleOtherTestingSelected}
                  value={ProductSelectionConst.OTHER_CATEGORY}
                />
              )}

              {selectedCategory === ProductSelectionConst.OTHER && (
                <OtherProductDetails />
              )}
              <RadioErrorMessage id="single-validation-error-message">
                {showCategorySelectedError === true ? (
                  <>
                    <Icon name="error" resolution="tiny" />
                    Please select Product before proceeding.
                  </>
                ) : (
                  ""
                )}
              </RadioErrorMessage>
            </RadioGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <ButtonGroup direction="right">
              <ButtonText onClick={() => ValidateAndProceed()}>Next</ButtonText>
            </ButtonGroup>
          </Col>
        </Row>
      </Grid>
    </>
  );
};

export default SelectProduct;
